import { gql } from '@apollo/client'
import productsFieldsQuery from '../../commons/fields/products'

/**
 * Gets the string for `recommendedForYouQuery` query.
 * Returns personalised product recommendations for the current user.
 * Ships dark in Phase 1 — wired in code but not yet activated by SCS config.
 * @internal
 */

const recommendedForYouQuery = gql`
  query RecommendedForYou(
    $storefrontName: String!,
    $sessionUid: ID!,
    $limit: Int
  ) {
    recommendedForYou(
      storefrontName: $storefrontName,
      sessionUid: $sessionUid,
      limit: $limit
    ) {
      items {
        ${productsFieldsQuery}
      }
    }
  }
`

export default recommendedForYouQuery
